<template>
	
    <div class="vpay__step" v-loading="loading">

		<h2 class="vpay__title-bar" @click="goBack"><ion-icon class="vpay__title-bar-close" name="arrow-back"></ion-icon>Back</h2>
		
		<VerificationCode
			ref="verificationCode"
			:client-id="$store.getters.client.id"
			:api-url="$store.getters.smsVerificationApiUrl"
			:tint-colour="$store.getters.brandColour"
			:user-phone-number="$store.getters.userPhoneNumber"
			scope="v-pay:payment"
			v-model="$store.state.mobileNumber"
			@event="onVerificationCodeEvent"/>
		
    </div>
	
</template>

<script>
	
	import { VerificationCode } from "./VerificationCode";
	
    export default {
		
        name: "PaymentFormStep2",
		
		components: { VerificationCode },
		
		methods: {
			
			onVerificationCodeEvent(e) {
				const nextButton = this.$refs.verificationCode.$el.getElementsByClassName("vpay__next-button")[0];
				if (process.env.NODE_ENV === "production") {
					this.loading = true;
					if (e.error) {
						this.loading = false;
						this.$errors.show(nextButton, { message: e.error });
					} else {
						if (e.name === "sendCode") {
							this.$store.commit("mobileNumberValidated", e.mobileNumber);
						} else if (e.name === "receiveCode") {
							this.loading = false;
						} else if (e.name === "codeVerified") {
							this.loading = false;
							this.$store.commit("incrementPaymentStep");
							this.$store.commit("isMobileNumberValidated", true);
						}
					}
				} else {
					this.$store.commit("incrementPaymentStep");
					this.$store.commit("mobileNumberValidated", e.mobileNumber);
					this.$store.commit("isMobileNumberValidated", true);
				}
			},

			goBack() {
				this.$store.commit("setPaymentStep", 1);
			}
			
		},
		
		data() {
			return {
				loading: false,
			};
		}
		
    }
	
</script>

<style>
	
	
	
</style>
